import React, { useContext, useMemo } from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';

import CoachesListContext from '../../../context/CoachesListContext';
import { LeadCampaignSource } from '../../../../Model/MassTextCampaign';

import { useCampaignCollection } from '../hooks/useCampaignCollection';
import texts from '../texts.json';

import CampaignTable from '../components/CampaignTable';
import metricColumns, { nameColumn, coachColumn } from '../components/campaignColumns';

const { reengagementHistory: copy } = texts;

const ReEngagementHistoryTab = () => {
  const {
    docs,
    loading,
    error,
  } = useCampaignCollection({ source: LeadCampaignSource.REENGAGEMENT_SEQUENCE });
  const { coachesList, isReady: coachesReady } = useContext(CoachesListContext);

  const columns = useMemo(() => [
    nameColumn(copy.columns),
    coachColumn(copy.columns, coachesList),
    ...metricColumns(copy.columns),
  ], [coachesList]);

  return (
    <Box sx={{ p: 3 }}>
      <CampaignTable
        docs={docs}
        columns={columns}
        loading={loading || !coachesReady}
        error={error}
        coachesList={coachesList}
        noticeText={copy.notice}
        emptyText={copy.empty}
        errorText={copy.error}
      />
    </Box>
  );
};

export default observer(ReEngagementHistoryTab);
